const e=(e,o)=>parseFloat(Number(e).toFixed(o));export{e as toFixed};
//# sourceMappingURL=toFixed.min.mjs.map
